import type { WarpExpandable } from "@warp-ds/elements/components/expandable";
import { Expandable } from "@warp-ds/elements/react/expandable";
import type { MouseEvent, ReactNode } from "react";

type Props = {
  title: ReactNode;
  /** Shown right-aligned next to the title, for rows that carry a spec value */
  value?: string;
  body: ReactNode;
  /** Optional "ask the seller" button, rendered under the body text */
  action?: ReactNode;
  /** Extra classes on the expandable, e.g. to hide a row that is shown elsewhere on wider screens */
  className?: string;
};

/**
 * One expandable row inside an EV info card: a title, an optional spec value, explainer
 * body text and an optional contact action.
 */
export const EvExpandableRow = ({ title, value, body, action, className }: Props) => {
  const onClick = (event: MouseEvent<WarpExpandable>) => {
    if (event.target !== event.currentTarget) return; // click inside the body, not the toggle
    if (event.currentTarget.expanded) {
      // TODO: MBJ-324 track open expandable click
    }
  };

  return (
    <Expandable
      box
      animated
      onClick={onClick}
      className={`border-b part-[wrapper]:s-bg hover:part-[wrapper]:s-bg-hover active:part-[wrapper]:s-bg-active part-[button]:px-0 ${className ?? ""}`}
    >
      <h3 className="w-full text-m m-0 font-normal flex justify-between mr-8" slot="title">
        {title}
        {value && <span className="font-bold">{value}</span>}
      </h3>
      <p className={`mt-0 ${action ? "mb-8" : "mb-16"}`}>{body}</p>
      {action && <div className="mb-16">{action}</div>}
    </Expandable>
  );
};
